/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "eu-central-1",
  aws_cognito_identity_pool_id:
    "eu-central-1:3464df8f-ad89-4c69-85cf-af6e9693bdc9",
  aws_cognito_region: "eu-central-1",
  aws_user_pools_id: "eu-central-1_bTx5HWArD",
  aws_user_pools_web_client_id: "1kjlkig0ahp3qbr3vfapns3fk1",
  oauth: {
    domain: "denali-stgeu.auth.eu-central-1.amazoncognito.com",
    scope: ["openid", "profile", "aws.cognito.signin.user.admin"],
    redirectSignIn: window.location.origin,
    redirectSignOut: `https://corpextdev.b2clogin.com/corpextdev.onmicrosoft.com/B2C_1A_OIDC_USERINFO_DENALI/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
    responseType: "code",
    client_id: "522f643d-5757-4085-b88d-c23004a8f0dd" //TODO: we need a production client id for federation
  },
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL", "NAME"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_appsync_graphqlEndpoint:
    "https://ap67g33mnzfrpi64ldxipf2kwu.appsync-api.eu-central-1.amazonaws.com/graphql",
  aws_appsync_region: "eu-central-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  appEnvironment: {
    BUILD_ENV: "stgeu",
    externalLinks: {
      traneConnectBaseURL: "https://stg.connect.tis.trane.eu",
      commandCenterBaseURL: "https://stg.tcc.tis.trane.eu",
      commandCenterGen4BaseURL: "https://gen4.tcc.tis-staging.trane.com/"
    }
  },
  predictions: {
    convert: {
      translateText: {
        region: "eu-central-1",
        proxy: false,
        defaults: {
          sourceLanguage: "en",
          targetLanguage: "zh"
        }
      },
      speechGenerator: {
        region: "eu-central-1",
        proxy: false,
        defaults: {
          VoiceId: "Ivy",
          LanguageCode: "en-US"
        }
      },
      transcription: {
        region: "eu-central-1",
        proxy: false,
        defaults: {
          language: "en-US"
        }
      }
    },
    identify: {
      identifyText: {
        proxy: false,
        region: "eu-central-1",
        defaults: {
          format: "PLAIN"
        }
      },
      identifyEntities: {
        proxy: false,
        region: "eu-central-1",
        celebrityDetectionEnabled: true,
        defaults: {
          collectionId: "identifyEntities8b89c648-test",
          maxEntities: 50
        }
      },
      identifyLabels: {
        proxy: false,
        region: "eu-central-1",
        defaults: {
          type: "LABELS"
        }
      }
    },
    interpret: {
      interpretText: {
        region: "eu-central-1",
        proxy: false,
        defaults: {
          type: "ALL"
        }
      }
    }   
  },
  "geo": {
        "amazon_location_service": {
            "region": "eu-central-1",
            "search_indices": {
                "items": [
                    "denalilocator-stgeu"
                ],
                "default": "denalilocator-stgeu"
            },
            "maps": {
                "items": {
                    "denalimap-stgeu": {
                        "style": "VectorEsriNavigation"
                    }
                },
                "default": "denalimap-stgeu"
            }
        }
    }
}

export const amplitudeKey = "" //"310d2b075694a4c3588727d46c057f22"
export default awsmobile
export const signOutUrl = `https://${awsmobile.oauth.domain}/logout?client_id=${awsmobile.aws_user_pools_web_client_id}&logout_uri=${awsmobile.oauth.redirectSignOut}&redirect_uri=${window.location.origin}&response_type=code`
export const APP_ID = "9b308188-33ad-4a84-8974-a412dc03e3f6"
export const remoteAccessURL = 'https://dev.api.tis.trane.com/remoteaccess/connect'
export const openVPNURL = 'https://api.tis-dev.trane.com/open-vpn-api/v2/remote'
export const staticFilesPath = "https://denali-staticfiles-rs42xyaee5e55navukocfivplm-eudev-eu-central-1.s3.amazonaws.com"
export const zendeskWidgetKey = "f42546cb-115b-4d5d-bf44-b4ddab8f10cd"

export const REACT_APP_API_ENDPOINT =
  "https://g9v0inu094.execute-api.us-east-1.amazonaws.com/dev/generate"
export const llmClientId = "pD6dOZoWO92F3MG0LIh5n8YtpivrdeIn7XWrc4Bw"

export const aiChatWebSocketURL="wss://tkb3v2yhof.execute-api.eu-central-1.amazonaws.com/stgeu/"
